import BaseApi from 'common/apiRequest/apis/BaseApi';
import { Request } from '../apiConcentrator/User';
import APINames from '../APINames';

class UserAccountsApi extends BaseApi {
  public requestInstance = new Request(APINames.ACCOUNTS);

  // 租户 换绑至其他手机号
  rebindMobileOfTenant(
    accountId: string,
    data: { verificationCode: string; verificationSessionId: string; mobile: string },
  ) {
    return this.requestInstance.post([accountId, ':rebind'], data);
  }
}
export default new UserAccountsApi();
